var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 3v3h12V3c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1M8 6V3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3h4c2.206 0 4 1.794 4 4v16c0 2.206-1.794 4-4 4H4c-2.206 0-4-1.794-4-4V10c0-2.206 1.794-4 4-4zm15 2H4c-1.106 0-2 .894-2 2v6h28v-6c0-1.106-.894-2-2-2zm7 10h-9v3c0 1.106-.894 2-2 2h-6c-1.106 0-2-.894-2-2v-3H2v8c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2zm-17 0v3h6v-3z"
  })));
};
export default SvgBriefcase;